<template>
    <div>
        <div class="flip-container">
            <div class="masechet-card">

                <div class="flipper">
                    <div class="front" v-bind:style="{'border-left-color': seder.color}">
                        <div>
                            <div class="main-section" v-on:click="navigateToSubComponent(masechet)">
                                <div>
                                    <div class="masechet-title">{{masechet.name}}</div>
                                    <div class="masechet-description">{{masechet.description}}</div>
                                </div>
                            </div>
                            <div class="footer" v-if="masechet.sponsor" v-on:click="navigateToSubComponent(masechet)">
                                <span>{{l10nMasechetSponsor}}:</span>
                                <span>{{masechet.sponsor.name}}</span>
                            </div>
                            <div class="footer" v-on:click="navigateToSponsorMasechet(masechet)" v-else>
                                <span class="no-sponsor">{{l10nThisDedicationIsWaitingForYou}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="back" v-bind:style="{'border-left-color': seder.color}">
                        <div class="border" v-bind:style="{'border-left-color': seder.color}">
                            <div class="main-section" v-on:click="navigateToSubComponent(masechet)">
                                <div>
                                    <div class="masechtot-count">
                                        <span v-if="masechet.pages">{{masechet.pages}} {{l10nShiurim}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="footer" v-if="masechet.sponsor" v-on:click="navigateToSubComponent(masechet)">
                                <span>{{l10nMasechetSponsor}}:</span>
                                <span>{{masechet.sponsor.name}}</span>
                            </div>
                            <div class="footer" v-on:click="navigateToSponsorMasechet(masechet)" v-else>
                                <span class="no-sponsor">{{l10nThisDedicationIsWaitingForYou}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

    import helpers from '../services/helpers'

    export default {
        name: 'category-card',
        props: {
            masechet: {
                type: Object,
                default: () => null
            },
            seder: {
                type: Object,
                default: () => null
            },
        },
        computed: {
            l10nMasechetSponsor() {
                return this.l10nGetter('masechet_sponsor')
            },
            l10nThisDedicationIsWaitingForYou() {
                return this.l10nGetter('this_dedication_is_waiting_for_you')
            },
            l10nShiurim() {
                return this.l10nGetter('shiurim')
            },
        },
        methods: {
            navigateToSubComponent: function (masechet) {
                this.$router.push({name: 'subcategory', params: {id: masechet.id.toString()}})
            },
            navigateToSponsorMasechet: function (masechet) {
                this.$router.push({
                    name: 'dedicationMasechet',
                    // params: {id: masechet.id.toString()}
                })
            },
            l10nGetter(key) {
                return helpers.uiTextGetter(this.$store, key)
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "../scss/main";

    .flip-container {
        perspective: 1000;
        margin: 13px 10px;

    }

    .flip-container:hover .flipper,
    .flip-container.hover .flipper {
        transform: rotateY(180deg);
    }

    $card-width: 260px;
    $card-height: 260px;
    $main-section-padding: 25px;
    $card-footer-height: 60px;
    .flip-container, .front, .back {
        width: $card-width;
        height: $card-height;
    }

    .masechet-card {
        cursor: pointer;

        width: $card-width;
        height: $card-height;
        .flipper {
            transition: 0.6s;
            transform-style: preserve-3d;
            position: relative;
        }

        .front, .back {
            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;

            position: absolute;
            top: 0;
            left: 0;
            box-shadow: 0 1px 13px 0 rgba(0, 0, 0, 0.17);
            border-left-style: solid;
            border-left-width: 2px;

        }

        .front {

            .main-section {
                background-color: #ffffff;
            }
        }
        .back {

            transform: rotateY(180deg);
            background-color: rgba(32, 58, 139, 0.97);

            .footer {
                color: white;

                .no-sponsor {
                    color: white;
                }
            }

        }

        .main-section {
            height: $card-height - $main-section-padding * 2 - $card-footer-height;
            text-align: center;
            padding: $main-section-padding 20px;

            .masechet-title {
                @include font-abraham(36px, $font-color-blue, 400);
                line-height: 58.129px;
            }
            .masechet-description {
                @include font-abraham(16px, $grey-1, 400);
                line-height: 19px;
            }

            .masechtot-count {
                @include font-abraham(30px, white, 400);
                line-height: 58.129px;
            }

        }
        .footer {
            $footer-background-color: rgba(220, 233, 239, 0.4);
            $footer-padding: 10px;
            height: $card-footer-height - $footer-padding * 2;
            background-color: $footer-background-color;
            @include font-abraham(19px, $font-color-lighter-blue, 400);
            text-align: center;
            padding: 10px 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .no-sponsor {
                @include font-abraham(12px, $grey-1, 400);
                text-decoration: underline;
            }
        }
    }

</style>
